import { mapEnumToOptions } from '@abp/ng.core';

export enum ProjectCheckListStatus {
  Embarked = 0,
  Disembarked = 1,
  Attended = 2,
  Cancelled = 3,
  Delivered = 4,
  Onboard = 5,
  Completed = 6,
  Forwarded = 7,
  WH = 8,
  VisaDA = 9,
  Collected = 10,
  Dispatched = 11,
  Landed = 12,
  Bay = 13,
  Office = 14,
  InProgress = 15,
}

export const projectCheckListStatusOptions = mapEnumToOptions(ProjectCheckListStatus);
